import React,{useEffect,useState} from "react";
import Preloader from "../helper/Preloader";
import HeaderOne from "../components/HeaderOne";
import BannerOne from "../components/BannerOne";
import FeatureOne from "../components/FeatureOne";
import PromotionalOne from "../components/PromotionalOne";
import FlashSalesOne from "../components/FlashSalesOne";
import ProductListOne from "../components/ProductListOne";
import OfferOne from "../components/OfferOne";
import RecommendedOne from "../components/RecommendedOne";
import HotDealsOne from "../components/HotDealsOne";
import TopVendorsOne from "../components/TopVendorsOne";
import BestSellsOne from "../components/BestSellsOne";
import DeliveryOne from "../components/DeliveryOne";
import OrganicOne from "../components/OrganicOne";
import ShortProductOne from "../components/ShortProductOne";
import BrandOne from "../components/BrandOne";
import NewArrivalOne from "../components/NewArrivalOne";
import ShippingOne from "../components/ShippingOne";
import NewsletterOne from "../components/NewsletterOne";
import FooterOne from "../components/FooterOne";
import BottomFooter from "../components/BottomFooter";
import ScrollToTop from "react-scroll-to-top";
import ColorInit from "../helper/ColorInit";
import ProductDetailsOne from "../components/ProductDetailsOne";
import ProductDetailsTwo from "../components/ProductDetailsTwo";
import { CartProvider } from "../contexts/CartContext";
import FooterTwo from "../components/FooterTwo";
import BannerThree from "../components/BannerThree";
import BigDealOne from "../components/BigDealOne";
import BannerTwo from "../components/BannerTwo";
import DealsOne from "../components/DealsOne";
import DaySaleOne from "../components/DaySaleOne";
import DealsSection from "../components/DealsSection";
import DiscountOne from "../components/DiscountOne";
import DiscountThree from "../components/DiscountThree";
import TextSlider from "../components/TextSlider";
import FeatureThree from "../components/FeatureThree";
import PromotionalTwo from "../components/PromotionalTwo";
import BannerFour from "../components/BannerFour";
import CustomSlider from "../components/CustomSlider";
import TopSellingOne from "../components/TopSellingOne";
import TopSellingTwo from "../components/TopSellingTwo";
import TrendingOne from "../components/TrendingOne";
import TrendingThree from "../components/TrendingThree";
import PopularProductsOne from "../components/PopularProductsOne";
import TrendingCustom from "../components/TrendingCustom";
import Products999 from "../components/products999";
import PromotionalSlider from "../components/PromotionalSlider";
import PromotionalSliderTwo from "../components/PromotionalSliderTwo";
import { getBanners } from "../services/nonAuthRequets";
import { S3_URL_BANNERS } from "../utils/constants";
import MainSlider from "../components/MainSlider";
import MobileViewBottomNav from "../components/MobileViewBottomNav";
import ShippingTwo from "../components/ShippingTwo";
import ShippingThree from "../components/ShippingThree";
import PromoBanner from "../components/PromoBanner";
const HomePageOne = () => {
  document.title = `Bigmall`;
  const [mainBanners, setMainBanners] = useState([]);
  const [subBannerLine1, setSubBannerLine1] = useState([]);
  const [subBannerLine2, setSubBannerLine2] = useState([]);
  const [modalBanner, setModalBanner] = useState([]);
  useEffect(() => {
    const fetchBanners = async () => {
      try {
        const response = await getBanners();
        if (response && response.length > 0) {
          // Map MAIN_BANNER_LINE banners
          const main = response
            .filter((banner) => banner.type === "MAIN_BANNER_LINE")
            .map((banner, index) => ({
              src: `${S3_URL_BANNERS}${banner.imageName}`,
              alt: banner.heading || `Banner ${index + 1}`,
              url: banner.url && banner.url.trim() ? banner.url : "/",
            }));

          // Map SUB_BANNER_LINE1 banners
          const sub1 = response
            .filter((banner) => banner.type === "SUB_BANNER_LINE1")
            .map((banner, index) => ({
              src: `${S3_URL_BANNERS}${banner.imageName}`,
              alt: banner.heading || `Sub Banner 1 - ${index + 1}`,
              url: banner.url && banner.url.trim() ? banner.url : "/",
            }));

          // Map SUB_BANNER_LINE2 banners
          const sub2 = response
            .filter((banner) => banner.type === "SUB_BANNER_LINE2")
            .map((banner, index) => ({
              src: `${S3_URL_BANNERS}${banner.imageName}`,
              alt: banner.heading || `Sub Banner 2 - ${index + 1}`,
              url: banner.url && banner.url.trim() ? banner.url : "/",
            }));

            const modals = response.filter(
              b => b.type === "MODAL_BANNER_LINE"
            ); 
            //console.log(modals, "modals in homepageone");
            modals.sort((a, b) =>
              new Date(b.createdAt) - new Date(a.createdAt)
            );
            const [latest] = modals;
           // console.log(latest, "latest in homepageone");
            const modalBanner = latest
      ? {
          src: `${S3_URL_BANNERS}${latest.imageName}`,
          alt: latest.heading || "Promotional Banner",
          url:
            latest.url && latest.url.trim()
              ? latest.url
              : "/",
        }
      : null;

          setMainBanners(main);
          setSubBannerLine1(sub1);
          setSubBannerLine2(sub2);
          setModalBanner(modalBanner);
        }
      } catch (error) {
        console.error("Error fetching banners:", error);
      }
    };

    fetchBanners();
  }, []);
 // console.log("Main",mainBanners);
 // console.log("Sub1",subBannerLine1);
  //console.log("sub2",subBannerLine2);
  //console.log("S3_URL_BANNERS",S3_URL_BANNERS);
  return (
    <CartProvider>
    
      <ScrollToTop smooth color="#ef253c" />
      <ColorInit color={'bigmall'} />
      <HeaderOne  />
      <CustomSlider banners={mainBanners} />
      {/* <MainSlider banners={mainBanners} /> */}
      <div className="px-20">
      {modalBanner && <PromoBanner banner={modalBanner} />}
      <TrendingCustom />
      <PromotionalSlider banners={subBannerLine1} />
      <Products999 />
      <PromotionalSlider banners={subBannerLine2} />
      <ProductListOne pageSize={18} />
      </div>
      <ShippingOne />
      <FooterOne />
      <BottomFooter />
      
    </CartProvider>
  
  );
};

export default HomePageOne;
